export default __webpack_public_path__ + "static/media/3d82d7a7-de70-4f67-85f4-78342de5fedb.562cb75f.woff2";